import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../AuthContext";
import { navRoutes } from "../AppRoutes";

const linkClasses =
    "text-[#64748b] hover:text-[#0f172a] hover:bg-[#f8fafc] px-3 py-2 rounded-lg text-sm transition";

const mobileLinkClasses =
    "block w-full text-[#64748b] hover:text-[#0f172a] hover:bg-[#f8fafc] px-3 py-2 rounded-lg text-base transition";

const activeLinkClasses = "bg-[#0f172a] text-white font-medium shadow-sm";

export class NavMenu extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.state = { open: false, openSubMenu: null };
    }

    toggleMenu = () => {
        this.setState(prev => ({ open: !prev.open }));
    };

    toggleSubMenu = (menu) => {
        this.setState(prev => ({
            openSubMenu: prev.openSubMenu === menu ? null : menu,
        }));
    };

    closeMenus = () => {
        this.setState({ open: false, openSubMenu: null });
    };

    getNavLinkClass = (isActive, mobile = false) => {
        const base = mobile ? mobileLinkClasses : linkClasses;
        return isActive
            ? `${base} ${activeLinkClasses}`
            : base;
    };

    getRouteLabel(route) {
        if (route.label) return route.label;
        if (route.path) return route.path.replace(/\//g, "");
        return "Home";
    }

    renderLinks(routes, isMobile = false, parentPath = "") {
        const { isAuthenticated, role } = this.context;
        const currentPath = window.location.pathname;

        return routes.map(route => {
            if (route.auth && !isAuthenticated) return null;
            if (route.admin && role !== "admin") return null;

            const hasChildren =
                Array.isArray(route.children) &&
                route.children.length > 0;

            const path = parentPath
                ? `${parentPath}/${route.path}`
                : route.path;

            const key = route.path || route.label;

            const isActiveParent =
                hasChildren &&
                currentPath.startsWith(path + "/");

            const baseClass = isMobile ? mobileLinkClasses : linkClasses;

            return (
                <div
                    key={key}
                    className={!isMobile && hasChildren ? "relative" : ""}
                >
                    {/* PARENT */}
                    {hasChildren ? (
                        <button
                            type="button"
                            onClick={() => this.toggleSubMenu(key)}
                            className={`${baseClass} ${isActiveParent
                                    ? activeLinkClasses
                                    : ""
                                } w-full text-left`}
                        >
                            <div className="flex items-center justify-between">
                                <span>{this.getRouteLabel(route)}</span>

                                <svg
                                    className={`w-4 h-4 transition-transform ${this.state.openSubMenu === key
                                            ? "rotate-180"
                                            : ""
                                        }`}
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                        </button>
                    ) : (
                        <NavLink
                            to={path || "/"}
                            end
                            onClick={this.closeMenus}
                            className={({ isActive }) =>
                                `${baseClass} w-full block ${isActive
                                    ? activeLinkClasses
                                    : ""
                                }`
                            }
                        >
                            {this.getRouteLabel(route)}
                        </NavLink>
                    )}

                    {/* SUBMENU */}
                    {hasChildren &&
                        this.state.openSubMenu === key && (
                            <div
                                className={
                                    isMobile
                                        ? "pl-4 mt-2 space-y-1"
                                        : `
                                            absolute
                                            left-0
                                            mt-2
                                            min-w-[200px]
                                            bg-white
                                            border
                                            border-[#e2e8f0]
                                            shadow-xl
                                            rounded-xl
                                            z-50
                                        `
                                }
                            >
                                <div className="flex flex-col py-2">
                                    {this.renderLinks(
                                        route.children,
                                        isMobile,
                                        path
                                    )}
                                </div>
                            </div>
                        )}
                </div>
            );
        });
    }

    render() {
        const { isAuthenticated } = this.context;

        return (
            <nav className="sticky top-0 z-50 bg-white border-b border-[#e2e8f0] shadow-sm transition-colors">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="flex justify-between h-16">

                        {/* LOGO */}
                        <div className="flex-shrink-0 flex items-center">
                            <NavLink
                                to="/"
                                className="flex items-center gap-2 text-[#0f172a] tracking-tight"
                                onClick={this.closeMenus}
                            >
                                <span className="w-8 h-8 rounded-lg bg-[#0f172a] text-white flex items-center justify-center text-sm">
                                    ⚡
                                </span>
                                <span className="font-bold text-xl">Haki</span>
                            </NavLink>
                        </div>

                        {/* DESKTOP */}
                        <div className="hidden sm:flex sm:items-center sm:space-x-4">
                            {this.renderLinks(navRoutes)}

                            {!isAuthenticated && (
                                <button
                                    onClick={() =>
                                        this.context.toggleLoginModal()
                                    }
                                    className="
                                        px-5 py-2 rounded-lg
                                        bg-[#0f172a] hover:bg-[#1e293b]
                                        text-white font-medium text-sm transition
                                    "
                                >
                                    Login
                                </button>
                            )}

                            {isAuthenticated && (
                                <button
                                    onClick={() =>
                                        this.context.logout()
                                    }
                                    className="
                                        px-4 py-2 rounded-lg
                                        border border-[#e2e8f0]
                                        text-[#64748b]
                                        hover:bg-[#f8fafc] hover:text-[#0f172a]
                                        transition text-sm
                                    "
                                >
                                    Logout
                                </button>
                            )}
                        </div>

                        {/* MOBILE BUTTON */}
                        <div className="flex items-center sm:hidden">
                                <button
                                    onClick={this.toggleMenu}
                                    className="
                                    p-2 rounded-lg
                                    text-[#64748b]
                                    hover:bg-[#f8fafc] hover:text-[#0f172a]
                                    transition
                                "
                                >
                                <svg
                                    className="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    {this.state.open ? (
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    ) : (
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    )}
                                </svg>
                            </button>
                        </div>

                    </div>
                </div>

                {/* MOBILE MENU */}
                {this.state.open && (
                    <div className="
                        sm:hidden
                        px-2 pt-2 pb-3 space-y-1
                        bg-white
                        border-t border-[#e2e8f0]
                    ">
                        {this.renderLinks(navRoutes, true)}

                        {!isAuthenticated && (
                            <button
                                onClick={() =>
                                    this.context.toggleLoginModal()
                                }
                                className="
                                    w-full mt-2 px-4 py-3 rounded-lg
                                    bg-[#0f172a] hover:bg-[#1e293b]
                                    text-white font-medium
                                "
                            >
                                Login
                            </button>
                        )}

                        {isAuthenticated && (
                                <button
                                    onClick={() =>
                                        this.context.logout()
                                    }
                                    className="
                                    w-full mt-2 px-4 py-3 rounded-lg
                                    border border-[#e2e8f0]
                                    text-[#64748b]
                                    hover:bg-[#f8fafc] hover:text-[#0f172a]
                                "
                                >
                                    Logout
                                </button>
                        )}
                    </div>
                )}
            </nav>
        );
    }
}

export default NavMenu;